module.exports = __webpack_public_path__ + "img/icon_map_6_on_011.604b6eee.png";